import { useState } from 'react';
import './SearchSelectList.scss';
import { isEmptyObject } from '../../Utils/Basic';

export interface IOption {
  name: string;
  code: string;
  value: string;
  CountryFullName?: string;
}

export interface ISearchSelectList {
  options: any;
  name: string;
  value: any;
  label?: string;
  handleChange: any;
  icon?: boolean;
  type?: string;
}

const SearchSelectList = (props: ISearchSelectList) => {
  const { options, name, label, icon, value, type } = props;
  const [showOptions, setShowOptions] = useState(false);

  const handleSelectChange = (option: any) => {
    setShowOptions(false);
    props.handleChange({ name, value: option });
  };

  return (
    <div className="Select_Wrapper" data-testid="SelectList">
      <div>
        <span>{label}</span>
      </div>
      <div
        className={`Select_Name ${type === 'NatNalEdit' ? 'NatNalSelect' : ''}`}
        data-testid="SelectName"
        onClick={() => setShowOptions(!showOptions)}
      >
        <div className="SelectInput_Container">
          {icon && <img src="/oo/assets/icon/search_icon.svg" alt="search icon" />}
          <p className="Selected_Value">
            {type === 'Country' || type === 'NatNalEdit'
              ? value
              : !isEmptyObject(value)
                ? value.name
                : 'None'}
          </p>
        </div>
        <div>
          <img src="/oo/assets/icon/grid-down-arrow.svg" alt="Arrow icon" />
        </div>
      </div>
      {options && showOptions ? (
        <div className={`Select_Options ${type === 'NatNalEdit' ? 'NatNalSelect' : ''}`}>
          {options.map((option: IOption, index: number) => {
            return (
              <div
                className={`Selected_Option${(typeof value === 'string' ? value === (option?.name || option?.value || option?.CountryFullName) : value === option) ? ' selected' : ''}`}
                key={index}
                onClick={() => handleSelectChange(option)}
              >
                <p>
                  {typeof option === 'string'
                    ? option
                    : option?.name || option?.value || option?.CountryFullName}
                </p>
              </div>
            );
          })}
        </div>
      ) : null}
    </div>
  );
};

export default SearchSelectList;
